import { useState, useEffect } from 'react';
import { useQuery } from 'react-query';

import { getRiskCategories } from 'services/portfolios';

export const riskCategoryAdapter = (riskCategory: RiskCategoryType) => riskCategory.reduce(
    (acc, risk) => ({
        ...acc,
        [risk.Id]: risk.Name,
    }),
    {},
);

export const usePortfolioName = (
    portfolioName?: string,
    riskCategory?: number,
) => {
    const [risk, setRisk] = useState({});
    const { isFetched, data, error } = useQuery({
        queryKey: ['getRiskCategories'],
        queryFn: getRiskCategories,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
    });

    useEffect(() => {
        if (data?.data) {
            const risks = data.data;

            setRisk(riskCategoryAdapter(risks));
        }
    }, [data?.data]);

    if (!riskCategory || !portfolioName) return { portfolioName: '', isLoading: false, error: '' };

    const name = `${portfolioName} ${risk[riskCategory]}`;

    if (!isFetched || !data) {
        return {
            portfolioName: '',
            isLoading: !isFetched,
            error,
        };
    }

    return {
        portfolioName: name,
        isLoading: !isFetched,
        error,
    };
};

type Risk = {
    Id: number;
    Name: string;
};

export type RiskCategoryType = Risk[];
